export const AllLeadState=[{
        id:'1',
        stateName:"Delhi",
       mainCity:"Delhi",
       
        
      },{ id:'2',
        stateName:"Maharashtra",
       mainCity:"Mumbai",
       
        
      },{ id:'3',
        stateName:"Karnataka",
       mainCity:"Bangalore",
       
        
      },{ id:'4',
        stateName:"West Bengal",
       mainCity:"Kolkata",
       
        
      },{ id:'5',
        stateName:"Tamil Nadu",
       mainCity:"Chennai",
       
        
      },{ id:'6',
        stateName:"Gujarat",
       mainCity:"Ahmedabad",
       
        
      },{ id:'7',
        stateName:"Chandigarh",
       mainCity:"Chandigarh",
       
        
      },{ id:'8',
        stateName:"Rajasthan",
       mainCity:"Jaipur",
       
        
      }]